import React from 'react';
import { MdVerified } from 'react-icons/md';


interface VerifiedBadgeProps {
    role?: string;
    className?: string; // Allow custom styling
}

const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({ role, className = '' }) => {
    // Only show for specific roles
    // If no role provided, assume we want to force show it (e.g. strict manual placement)
    // Or we can default to showing it if role is 'admin' or 'bqt'

    // List of roles that deserve a verified tick
    const verifiedRoles = ['admin', 'bqt', 'moderator'];

    if (role && !verifiedRoles.includes(role)) {
        return null;
    }

    return (
        <span
            className={`inline-flex items-center justify-center shrink-0 ${className || 'w-3.5 h-3.5'}`}
            title="Đã xác minh"
        >
            <MdVerified className="w-full h-full text-[#1877F2]" />
        </span>
    );
};

export default VerifiedBadge;
